/**
 * Detect the active portal from the hostname subdomain.
 *
 * Legacy subdomains: retail.*, manager.*, vault.*, distributor.*
 * Fallback: 'retail' when no recognized subdomain (e.g. localhost).
 */

export type Portal = 'retail' | 'manager' | 'vault' | 'distributor';

const PORTAL_MAP: Record<string, Portal> = {
  retail: 'retail',
  manager: 'manager',
  vault: 'vault',
  distributor: 'distributor',
};

export function getPortal(): Portal {
  const hostname = window.location.hostname;
  const sub = hostname.split('.')[0];
  return PORTAL_MAP[sub] ?? 'retail';
}

export function getLoginType(portal: Portal): 'retail' | 'manager' {
  switch (portal) {
    case 'manager':
    case 'distributor':
      return 'manager';
    default:
      return 'retail';
  }
}
